import approvals from "./approvals";
import reviews from './reviews';

export default {
    approvals: approvals,
    reviews: reviews,
}